import React from 'react'

import Layout from '../components/layout'
import TestimonialSlider from '../components/homepage-carousel'
import FeatureViewer from '../components/feature-viewer'

import bannerPhones from '../images/banner-phones.svg'
import bannerPhonesMobile from '../images/banner-phones-mobile.png'
import introImage from '../images/CTA-image.png'
import introImageMobile from '../images/introduction-mobile.png'
import taxIconMobile from '../images/tax-icon-mobile.png'
import shopIconMobile from '../images/shop-icon-mobile.png'
import paperworkIconMobile from '../images/paperwork-icon-mobile.png'

const IndexPage = () => {
  return (
    <Layout>
      <div className="section section--banner">
        <div className="section__inner">
          <div className="section__half section__half--left">
            <h1>在您的手机上进行英国免税购物</h1>
            <a href="#footer-links" className="button">获取App</a>
          </div>
          <div className="section__half section__half--right">
            <img className="image--desktop" src={bannerPhones} alt="Airvat Phone Demo" />
            <img className="image--mobile" src={bannerPhonesMobile} alt="Airvat Phone Demo" />
          </div>
        </div>
      </div>
      <div className="section section--introduction">
        <div className="section__inner">
          <div className="section__half introduction--left">
            <img className="image--desktop" src={introImage} alt="Easy to use" />
            <img className="image--mobile" src={introImageMobile} alt="Easy to use" />
          </div>
          <div className="section__half introduction--right">
            <div className="introduction__content">
              <h2 className="gradient-bg">我们致力于为访问英国的非欧盟居民提供更好的英国免税购物服务</h2>
              <div className="introduction__point">
                <img src={taxIconMobile} alt="Tax" className="mobile-icon" />
                <h3>获得更多英国退税详情</h3>
                <p className="large">店内英国退税公司会向您收取高达50%的佣金、费用和汇率. 我们的收费要低得多，因此您可以获得更多退税</p>
              </div>
              <div className="introduction__point">
                <img src={shopIconMobile} alt="Tax" className="mobile-icon" />
                <h3>任何商店，想购就购</h3>
                <p className="large">在英国的任何实体店都可使用我们的退税App. 无论您是在高档百货商店还是小型纪念品商店，都可以享受同样的服务</p>
              </div>
              <div className="introduction__point">
                <img src={paperworkIconMobile} alt="Tax" className="mobile-icon" />
                <h3>我们替您做那些无聊的手续工作</h3>
                <p className="large">无需再手动填写不同商店的各种表单. 我们将您所有的收据放入一张退税单中</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section section--features">
        <div className="section__inner">
          <FeatureViewer></FeatureViewer>
        </div>
      </div>
      <div className="section section--testimonials">
        <div className="section__inner">
          <h2 className="gradient-bg">客户评价</h2>
          <TestimonialSlider></TestimonialSlider>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage